import React from 'react';
import { Card } from 'react-bootstrap';
import Phases from '../../../../components/form/Phases';
const Body = () => {
    return (
        <Card.Body className='mb-3'>
            <Phases />
            <h6>Vamos começar:</h6>
            <Card.Title>
                Veja o valor disponível para saque imediato
            </Card.Title>
            <Card.Text>Selecione uma das opções abaixo</Card.Text>
        </Card.Body>
    );
};

export default Body;
